export default __webpack_public_path__ + "static/media/bi.69b06700.svg";